import { render, staticRenderFns } from "./workArea.vue?vue&type=template&id=53799e04&scoped=true&"
import script from "./workArea.vue?vue&type=script&lang=js&"
export * from "./workArea.vue?vue&type=script&lang=js&"
import style0 from "./workArea.vue?vue&type=style&index=0&id=53799e04&prod&lang=less&scoped=true&"
import style1 from "./workArea.vue?vue&type=style&index=1&id=53799e04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53799e04",
  null
  
)

export default component.exports